export const CITY_ALL_SHORT = 'cityAllShort'
export const CITY_SEARCH = 'citySearch'
export const CITY_REGIONS = 'cityRegions'
